/*!
 * Copyright 2021 Cognite AS
 */

export enum LevelOfDetail {
  Discarded,
  Simple,
  Detailed
}
